import React from "react";
import { TESTIMONIALS } from "../lib/site-data";
import { Quote, Star } from "lucide-react";

export default function Testimonials() {
  return (
    <section
      id="testimonials"
      className="py-20 lg:py-28 bg-white"
      data-testid="testimonials-section"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mb-14">
          <div className="text-sm font-medium text-[#D97706] uppercase tracking-widest mb-3">
            What Parents Say
          </div>
          <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight text-[#0F172A] leading-tight">
            Real progress,
            <br />
            <span className="text-[#1E3A8A]">noticed at home.</span>
          </h2>
          <p className="mt-5 text-base sm:text-lg text-[#475569] leading-relaxed">
            A few words from the parents who&apos;ve trusted us with their
            child&apos;s primary years.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
          {TESTIMONIALS.map((t, i) => (
            <article
              key={t.id}
              className={`relative bg-[#FAFAFA] rounded-3xl p-8 lg:p-9 border border-[#E2E8F0] hover:-translate-y-1 hover:shadow-md transition-all flex flex-col ${
                i === 1 ? "md:translate-y-4" : ""
              }`}
              data-testid={`testimonial-card-${t.id}`}
            >
              <Quote className="w-9 h-9 text-[#1E3A8A]/15 absolute top-6 right-6" />
              <div className="flex items-center gap-1 text-[#D97706] mb-5">
                {[0, 1, 2, 3, 4].map((s) => (
                  <Star key={s} className="w-4 h-4 fill-current" />
                ))}
              </div>
              <blockquote className="text-[#0F172A] leading-relaxed flex-1">
                &ldquo;{t.quote}&rdquo;
              </blockquote>
              <div className="mt-7 pt-6 border-t border-[#E2E8F0] flex items-center gap-3">
                <div
                  className="w-11 h-11 rounded-full bg-[#1E3A8A] text-white flex items-center justify-center font-heading font-semibold text-sm flex-shrink-0"
                  aria-hidden="true"
                >
                  {t.initials}
                </div>
                <div>
                  <div className="font-heading font-semibold text-[#0F172A] text-sm">
                    {t.parent}
                  </div>
                  <div className="text-xs text-[#475569]">{t.child}</div>
                </div>
              </div>
            </article>
          ))}
        </div>

        <p className="mt-10 text-xs text-[#475569] text-center max-w-xl mx-auto italic">
          Names changed for privacy.
        </p>
      </div>
    </section>
  );
}
